import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { TituloReceberPerspectivaSelectModule } from '../../../../titulo-receber/perspectiva';
import { TituloReceberFilterModule } from '../../../../titulo-receber/filter';
import { TituloReceberTableModule } from '../../../../titulo-receber/view/table';
import { TituloReceberFormModalModule } from '../../../../titulo-receber/form/modal';

import { ClienteTituloReceberViewComponent } from './cliente-titulo-receber-view.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberPerspectivaSelectModule,
        TituloReceberFilterModule,
        TituloReceberTableModule,
        TituloReceberFormModalModule
    ],
    declarations: [
        ClienteTituloReceberViewComponent
    ],
    exports: [
        ClienteTituloReceberViewComponent
    ]
})
export class ClienteTituloReceberViewModule { }
